












































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { State } from "vuex-class";

import { TaskData } from "@/types";

import Task from "@/components/Task.vue";
import { getDate } from "@/date-helper";
import { setTimeout } from "timers";

@Component({ components: { Task } })
export default class Organizer extends Vue {
  @State("tasks")
  private tasks!: TaskData[];
  private newTask: TaskData | null = null;

  private isSorting = false;

  private getDateWithOffset(offset: number) {
    return getDate(offset);
  }

  private getDayNameFromOffset(offset: number) {
    if (offset === 0) {
      return "Today";
    } else if (offset === 1) {
      return "Tomorrow";
    } else {
      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ];
      return days[this.getDateWithOffset(offset).getDay()];
    }
  }

  private getTasksByDateOffset(offset: number) {
    const date = this.getDateWithOffset(offset);

    return this.tasks
      .filter(
        (task: TaskData) => task.date.toDateString() === date.toDateString()
      )
      .sort((a, b) => {
        if (a.order > b.order) {
          return 1;
        } else if (a.order < b.order) {
          return -1;
        } else {
          return 0;
        }
      });
  }

  private createNewTaskWithDateOffset(offset: number) {
    const daysTasks = this.getTasksByDateOffset(offset);

    this.newTask = {
      id: undefined,
      description: "",
      date: this.getDateWithOffset(offset),
      order:
        daysTasks.length > 0 ? daysTasks[daysTasks.length - 1].order + 1 : 0,
      done: false
    };
  }

  private closeNewTask() {
    this.$nextTick(() => {
      this.newTask = null;
    });
  }

  private startSorting() {
    this.isSorting = true;
  }
  private stopSorting() {
    this.isSorting = false;
  }

  private handleDropEnter(
    offset: number,
    transferData: { details: TaskData },
    event: DragEvent
  ) {
    this.$store.commit("updateTask", {
      ...transferData.details,
      date: this.getDateWithOffset(offset),
      order: 0.5
    });
  }
}
